import React from 'react';
import { CheckIcon } from 'lucide-react';
import { modules } from '../data/content';
export function Modules() {
  return <section aria-label="Included modules" className="bg-navy-soft px-3 py-4 sm:px-6" data-id="element-114" data-mp="1r51250zgqi6v">
      <div className="mx-auto max-w-2xl space-y-2" data-id="element-115" data-mp="1vy3lkgaj0b9c">
        {modules.map(mod => <article key={mod.number} className="overflow-hidden rounded-md border border-navy-line bg-navy" data-id="element-116" data-mp="20wew6t8napsm">
            <div className="flex items-center gap-1.5 border-b border-navy-line bg-signal/10 px-2.5 py-1.5" data-id="element-117" data-mp="146xu0o8vflvo">
              <CheckIcon className="h-3.5 w-3.5 shrink-0 text-gold" strokeWidth={3} aria-hidden="true" data-id="element-118" data-mp="1889b25doiys9" />
              <h3 className="font-display text-[0.68rem] font-extrabold uppercase leading-tight text-signal sm:text-[0.86rem]" data-id="element-119" data-mp="1d5t265vh761m">
                MODULE {mod.number} — {mod.title}
              </h3>
            </div>
            <p className="px-2.5 py-2 text-[0.78rem] leading-[1.35] text-white/80 sm:text-[0.92rem]" data-id="element-120" data-mp="2olhocv0wo11d">{mod.body}</p>
          </article>)}
      </div>
    </section>;
}